import * as Models from 'models';
import { removeSSIAnchor } from '../Plugins/SSIAnchorPlugin/utils/removeSSIAnchor';

export function removeSSIAnchorOnComponent(
  document: Models.TextComponentMap,
  anchorBlockKey: string,
): Models.TextComponentMap {
  const lexicalState = document.get('lexicalState');
  if (!lexicalState) {
    return document;
  }
  const newLexicalState = removeSSIAnchor(lexicalState, anchorBlockKey);

  return document.set('lexicalState', newLexicalState);
}
